import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { RealtimeActivity } from '~/features/dashboard/types/dashboard.type';

/**
 * 실시간 활동 로그 조회
 * @description 최근 실시간 활동 로그를 조회합니다
 * @endpoint GET /admin/dashboard/realtime-activities
 * @param limit - 조회할 개수 (기본값: 20)
 */
export function getDashboardRealtimeActivitiesApi(limit?: number) {
  return axiosInstance.get<ApiResponse<RealtimeActivity[]>>(
    '/admin/dashboard/realtime-activities',
    {
      params: limit ? { limit } : undefined,
    },
  );
}
